import { Injectable } from '@angular/core';
import { Observable, map, take } from 'rxjs';
import { Locale } from '../../domain/entities/locale';
import { LocaleValidationService } from '../../domain/services/locale-validation.service';
import { GetUserUseCase } from '../../../domain/user/use-cases/get-user-use-case';
import { User } from '../../../domain/user/entities/user';

@Injectable({
    providedIn: 'root',
})
export class LoadUserLocaleUseCase {
    private readonly localeValidationService: LocaleValidationService =
        new LocaleValidationService();

    public constructor(private getUserUseCase: GetUserUseCase) {}

    public execute(userId: string): Observable<Locale | null> {
        return this.getUserUseCase.execute({ userId }).pipe(
            take(1),
            map((user: User) =>
                this.localeValidationService.normalizeCandidate(user?.attributes?.lang ?? null),
            ),
        );
    }
}
